import { jsx as _jsx } from "react/jsx-runtime";
export default function Text(props) {
    const { children, ...otherProps } = props;
    return _jsx("text", Object.assign({}, otherProps, { children: children }), void 0);
}
//# sourceMappingURL=Text.js.map